// src/modules/fcm/actions.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import apiCall from '../../utils/api';

export const setFcmToken = createAsyncThunk(
  'fcm/setFcmToken',
  async (fcmToken: string, { rejectWithValue }) => {
    try {
      const response = await apiCall<{ status: boolean; message: string }>(
        'POST',
        '/auth/set-fcm-token/',
        { fcm_token: fcmToken }
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data.message || 'Failed to set FCM token');
    }
  }
);